import { useCallback, useState } from 'react';
import { TextField } from '@mui/material';
import { Modal } from '@trinity/chat-components/components/Modal/Modal.js';
import Button from '@trinity/chat-components/components/presentation/Button/index.js';
import type { LinkSelection } from './Context';
import styles from './style/Link.Modal.module.css';

type Props = {
  canEditText: boolean;
  onCancel: () => void;
  onSubmit: (value: SubmitParams) => void;
  selection: LinkSelection;
};

type SubmitParams = {
  href: string;
  text: string;
};

export const LinkExtensionModal = ({
  canEditText,
  onCancel,
  onSubmit,
  selection,
}: Props) => {

  const [text, setText] = useState(selection.text || '');
  const [href, setHref] = useState(selection.href || '');

  const canSave = href && text;

  const handleSubmit = useCallback(() => {
    onSubmit({ href, text });
  }, [
    href,
    onSubmit,
    text,
  ]);

  const handleHrefKeyPress = useCallback(({ key }: React.KeyboardEvent<HTMLInputElement>) => {
    if (key === 'Enter' && canSave) {
      handleSubmit();
    }

    if (key === 'Escape') {
      onCancel();
    }
  }, [
    canSave,
    handleSubmit,
    onCancel,
  ]);

  return (
    <Modal
      open={true}
      className={styles.modalWrap}
      hideCloseIcon={true}>
      <div className={styles.main}>
        <div className={styles.form}>

          <div className={styles.row}>
            <div className={styles.label}>Text</div>
            {!canEditText
              ? <div className={styles.input}>{text}</div>
              : <TextField
                fullWidth
                defaultValue={text}
                className={styles.input}
                onChange={e => setText(e.target.value)}
                variant='standard' />}
          </div>

          <div className={styles.row}>
            <div className={styles.label}>Link</div>

            <TextField
              fullWidth
              onChange={e => setHref(e.target.value)}
              value={href}
              onKeyPress={handleHrefKeyPress}
              variant='standard' />
          </div >

          <div className={styles.row}>
            <div className={styles.btns}>
              <Button
                className={styles.btn}
                color="destructive"
                onClick={onCancel}
                variant="brick">
                Cancel
              </Button>
              <Button
                className={styles.btn}
                disabled={!canSave}
                onClick={handleSubmit}
                variant="brick">
                Save
              </Button>
            </div>
          </div>
        </div >
      </div >
    </Modal >
  );
};
